import _ from 'lodash';
import axios from 'axios';
import { getI18n } from 'react-i18next';
import { showErrorNotification, showInfoNotification } from './notifications';
import Constants from '../utils/Constants';
import { createErrorMessage } from '../components/errors/Errors';
import {
    VALIDATION_INVALID_USER_ID,
    VALIDATION_NEW_PASSWORD_TOKEN_INVALID,
    VALIDATION_NEW_PASSWORD_UNEXPECTED
} from '../components/errors/PasswordErrors';

export const RESET_PASSWORD_STORE_TOKEN = 'RESET_PASSWORD_STORE_TOKEN';
export const RESET_PASSWORD_TOKEN_INVALIDATED = 'RESET_PASSWORD_TOKEN_INVALIDATED';

const onSuccess = (dispatch) => (resp) => {
    if (resp.data && resp.data.twoFAtoken) {
        window.location.href = 'login?reset2faToken=' + resp.data.twoFAtoken;
    }
    dispatch(showInfoNotification(getI18n().t('reset-password.notification.success')));
    dispatch(resetPasswordTokenInvalidated());
};

const onTokenValidSuccess = (dispatch, token) => () => {
    dispatch(storeResetPasswordToken(token));
};

const onError = (dispatch) => (error) => {
    const { response } = error;
    if (response && response.data && _.isArray(response.data)) {
        let isNonValidationError = false;
        response.data.forEach((errObject) => {
            const message = createErrorMessage(errObject.code, errObject.params);
            dispatch(showErrorNotification(message));
            if (!isNonValidationError && (errObject.code === VALIDATION_INVALID_USER_ID || errObject.code === VALIDATION_NEW_PASSWORD_TOKEN_INVALID)) {
                isNonValidationError = true;
            }
        });
        if (isNonValidationError) {
            dispatch(resetPasswordTokenInvalidated());
        }
    } else {
        const errorMessageCode = VALIDATION_NEW_PASSWORD_UNEXPECTED;
        const errorMessageParams = { message: error.message };
        const message = createErrorMessage(errorMessageCode, errorMessageParams);
        dispatch(showErrorNotification(message));
        dispatch(resetPasswordTokenInvalidated());
    }
};

export const storeResetPasswordToken = (token) => ({
    type: RESET_PASSWORD_STORE_TOKEN,
    payload: {
        token,
    },
});

export const resetPasswordTokenInvalidated = () => ({
    type: RESET_PASSWORD_TOKEN_INVALIDATED,
});

export const resetPassword = (token, newPassword, repeatPassword) => (dispatch) => axios
    .post(Constants.RESET_PASSWORD_PATH, { token, newPassword, repeatPassword })
    .then(onSuccess(dispatch))
    .catch(onError(dispatch));

export const checkPwdResetLink = (token) => (dispatch) => axios
    .post(Constants.RESET_LINK_VALIDITY, { token })
    .then(onTokenValidSuccess(dispatch, token))
    .catch(onError(dispatch));
